import { render, staticRenderFns } from "./edit-internal-officer.vue?vue&type=template&id=a5168ce2&scoped=true"
import script from "./edit-internal-officer.vue?vue&type=script&lang=js"
export * from "./edit-internal-officer.vue?vue&type=script&lang=js"
import style0 from "./edit-internal-officer.vue?vue&type=style&index=0&id=a5168ce2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5168ce2",
  null
  
)

export default component.exports